import { useTranslation } from '../../contexts/LanguageContext'
import { useIsMac } from '../../hooks/useKeyboardShortcuts'
import { Modal } from './Modal'

interface ShortcutsModalProps {
  isOpen: boolean
  onClose: () => void
}

export function ShortcutsModal({ isOpen, onClose }: ShortcutsModalProps) {
  const isMac = useIsMac()
  const { t } = useTranslation()
  const mod = isMac ? '⌘' : 'Ctrl'

  const shortcuts = [
    { keys: `${mod} + Z`, description: t.shortcuts.undo },
    { keys: `${mod} + Shift + Z`, description: t.shortcuts.redo },
    { keys: `${mod} + S`, description: t.shortcuts.save },
    { keys: `${mod} + P`, description: t.shortcuts.downloadPdf },
    { keys: `${mod} + /`, description: t.shortcuts.showShortcuts },
  ]

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="p-6">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-10 h-10 rounded-xl bg-slate-100 flex items-center justify-center">
            <svg className="w-5 h-5 text-slate-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          </div>
          <div>
            <h2 className="text-lg font-bold text-slate-900">{t.shortcuts.title}</h2>
            <p className="text-sm text-slate-500">{t.shortcuts.subtitle}</p>
          </div>
        </div>

        <div className="space-y-2">
          {shortcuts.map((shortcut) => (
            <div
              key={shortcut.keys}
              className="flex items-center justify-between py-2.5 px-3 rounded-lg hover:bg-slate-50"
            >
              <span className="text-sm text-slate-700">{shortcut.description}</span>
              <kbd className="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-mono font-medium text-slate-600 bg-slate-100 border border-slate-200 rounded-md">
                {shortcut.keys}
              </kbd>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  )
}
